import { render, staticRenderFns } from "./trust-deed-list.vue?vue&type=template&id=69ae57d7"
import script from "./trust-deed-list.vue?vue&type=script&lang=js"
export * from "./trust-deed-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports